import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { pageTypeConstants } from '../../../constants/pageTypeConstants';

// components
import { SbSharedRefineMenuInputRangeCurrency } from '../../SbSharedRefineMenu/SbSharedRefineMenuInputRange/SbSharedRefineMenuInputRangeCurrency';
import { SbSharedRefineMenuPriceRanges } from '../../SbSharedRefineMenu/SbSharedRefineMenuPriceRanges/SbSharedRefineMenuPriceRanges';
import { SbSharedRefineMenuSaleInput } from '../../SbSharedRefineMenu/SbSharedRefineMenuSaleInput/SbSharedRefineMenuSaleInput';
import { SbSharedRefineMenuNoReserve } from '../../SbSharedRefineMenu/SbSharedRefineMenuNoReserve/SbSharedRefineMenuNoReserve';
import { SbSharedRefineMenuNetPriceTradeDiscount } from '../../SbSharedRefineMenu/SbSharedRefineMenuNetPriceTradeDiscount/SbSharedRefineMenuNetPriceTradeDiscount';

import { SbMobileRefineMenuFilterPrice_user$key } from './__generated__/SbMobileRefineMenuFilterPrice_user.graphql';
import { SbMobileRefineMenuFilterPrice_itemSearch$key } from './__generated__/SbMobileRefineMenuFilterPrice_itemSearch.graphql';

const { AUCTION } = pageTypeConstants;

type Props = {
    currency: string;
    user: SbMobileRefineMenuFilterPrice_user$key;
    itemSearch: SbMobileRefineMenuFilterPrice_itemSearch$key;
};

export const SbMobileRefineMenuFilterPrice: FC<Props> = props => {
    const { user: userRef, itemSearch: itemSearchRef } = props;

    const user = useFragment(
        graphql`
            fragment SbMobileRefineMenuFilterPrice_user on User {
                ...SbSharedRefineMenuPriceRanges_user
            }
        `,
        userRef
    );

    const itemSearch = useFragment(
        graphql`
            fragment SbMobileRefineMenuFilterPrice_itemSearch on ItemSearchQueryConnection {
                ...SbSharedRefineMenuInputRangeCurrency_itemSearch
                ...SbSharedRefineMenuPriceRanges_itemSearch
                ...SbSharedRefineMenuSaleInput_itemSearch
                ...SbSharedRefineMenuNoReserve_itemSearch
                ...SbSharedRefineMenuNetPriceTradeDiscount_itemSearch
                pageType
            }
        `,
        itemSearchRef
    );

    return (
        <>
            <SbSharedRefineMenuPriceRanges {...props} user={user} itemSearch={itemSearch} />
            <SbSharedRefineMenuInputRangeCurrency {...props} itemSearch={itemSearch} applyOnBlur />
            <SbSharedRefineMenuNetPriceTradeDiscount itemSearch={itemSearch} />
            {itemSearch?.pageType === AUCTION ? (
                <SbSharedRefineMenuNoReserve {...props} itemSearch={itemSearch} />
            ) : (
                <SbSharedRefineMenuSaleInput {...props} itemSearch={itemSearch} />
            )}
        </>
    );
};
